module.exports = __webpack_public_path__ + "img/svg/background-competitions-warriors.fc3bb7757fb1e066338b8a264dc54111.svg";